import { configService } from "./Config/ConfigService";

class AbpnClient {
  private _baseUri: string | undefined;
  private _errorPage: string | undefined;

  private async ensureConfiguration() {
    if (this._baseUri) return;
    this._baseUri = (await configService.getConfiguration()).AbpnApiUrl;
  }

  private async validateResponse(response: Response): Promise<Response> {
    if (!response.ok) {
      const text = await response.clone().text();
      throw Error(`(${response.statusText}) ${text}`);
    }
    return Promise.resolve(response);
  }

  private async castResponse<T>(response: Response): Promise<T | null> {
    const text = await response.text();
    if (!text) return null;
    return JSON.parse(text) as T;
  }

  private async handleError(error: any): Promise<any> {
    if (this._errorPage) {
      window.location.href = this._errorPage;
    }
    return Promise.reject(error);
  }

  setErrorPage(errorPage: string) {
    this._errorPage = errorPage;
  }

  async get<T>(relativePath: string): Promise<T> {
    await this.ensureConfiguration();

    return fetch(this._baseUri + relativePath, {
      method: "GET",
      cache: "no-store"
    })
      .then(this.validateResponse)
      .then(response => this.castResponse<T>(response))
      .catch(error => this.handleError(error));
  }
}

export const abpnClient = new AbpnClient();
